import { wagmiConfig } from "@/config";
import { waitForTransactionReceipt } from "@wagmi/core";
import type { TransactionHash } from "@/types";

export const waitForTransactionConfirmMock = (transactionHash: TransactionHash) => {
    // Mock for development
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve({
                confirmations: 2,
                blockHash: transactionHash,
                blockNumber: BigInt(1234),
                transactionHash: transactionHash,
                status: "success",
            });
        }, 2000); // Simulate 2s confirmation time
    });
};

export const waitForTransactionConfirm = (transactionHash: TransactionHash) => {
    return waitForTransactionReceipt(wagmiConfig, {
        confirmations: 2,
        hash: transactionHash,
    });
};

export const truncateAddress = (addr: string) => {
    return `${addr.slice(0, 6)}...${addr.slice(-4)}`;
};
